// extracted by mini-css-extract-plugin
export default {"container":"JF-z","disabled":"KF-z","bgBlack":"LF-z","content":"MF-z","countdown":"NF-z","topCaption":"OF-z","topHeading":"PF-z","heading":"QF-z","copy":"RF-z"};